module.exports = __webpack_public_path__ + "img/whats-new.7ded7751.png";